import { useEffect, useState } from "react";
import { isIOS, isAndroid } from "react-device-detect";

const STORE_URLS = {
  IOS: "https://apps.apple.com/ca/app/evo/id972393570",
  ANDROID:
    "https://play.google.com/store/apps/details?id=com.vulog.android.carsharing.vancouver"
};

/**
 * DeepLinkRouter — fallback page for the /open route.
 *
 * How it works:
 * - iOS Universal Links and Android App Links are configured so that
 *   the OS intercepts navigation to /open and opens the app directly.
 * - If the app is NOT installed, the OS does not intercept and this
 *   web page loads instead.
 * - This component simply detects the platform and redirects:
 *     • iOS → App Store
 *     • Android → Play Store
 *     • Desktop → evo.ca website
 */
const DeepLinkRouter = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      if (isIOS) {
        window.location.href = STORE_URLS.IOS;
      } else if (isAndroid) {
        window.location.href = STORE_URLS.ANDROID;
      } else {
        window.location.href = process.env.REACT_APP_DESKTOP_FALLBACK_URL;
      }
    } catch (err) {
      setError("Unable to redirect. Please try again or visit evo.ca directly.");
    }
  }, []);

  if (error) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <p style={{ color: "red", marginBottom: "20px" }}>{error}</p>
        <a href="/" style={{ display: "inline-block", textDecoration: "underline" }}>
          Go to Home Page
        </a>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <p>Redirecting...</p>
    </div>
  );
};

export default DeepLinkRouter;
